import React from 'react';

const SettingsTab = ({ settings = {}, achievements = {}, onSaveSettings }) => {
    return (
        <div className="admin-tab-content">
            {/* ABOUT US METRIC COUNTERS */}
            <div className="admin-card">
                <div className="card-header">
                    <h3><i className="fa fa-trophy m-r10" style={{ color: '#f03a02' }} /> About Us Metric Counters</h3>
                </div>
                <div className="card-body">
                    <form onSubmit={onSaveSettings}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                            <div>
                                <label className="admin-label">Years Experience</label>
                                <input type="text" className="admin-input" name="yearsExperience" defaultValue={achievements.yearsExperience || '16+'} required />
                            </div>
                            <div>
                                <label className="admin-label">Projects Completed</label>
                                <input type="text" className="admin-input" name="projectsCompleted" defaultValue={achievements.projectsCompleted || '1100+'} required />
                            </div>
                            <div>
                                <label className="admin-label">Client Satisfaction</label>
                                <input type="text" className="admin-input" name="clientSatisfaction" defaultValue={achievements.clientSatisfaction || '100%'} required />
                            </div>
                        </div>

                        <button type="submit" className="admin-btn admin-btn-primary m-t20">
                            <i className="fa fa-save m-r5" /> Save About Us Metric Counters
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SettingsTab;
